import { useState } from 'react';
import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { experimentalStyled } from '@mui/material/styles';
import { MainNavbar } from './MainNavbar';
import { MainSidebar } from './MainSidebar';
import { Footer } from './Footer';

interface MainLayoutProps {
    children?: ReactNode;
}

const MainLayoutRoot = experimentalStyled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    paddingTop: 64,
}));

export const MainLayout: FC<MainLayoutProps> = ({ children }) => {
    const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState<boolean>(false);

    return (
        <MainLayoutRoot>
            <MainNavbar showMenu={true} onSidebarMobileOpen={(): void => setIsSidebarMobileOpen(true)} />
            <MainSidebar onMobileClose={(): void => setIsSidebarMobileOpen(false)} openMobile={isSidebarMobileOpen} />
            <Box sx={{ minHeight: '80vh' }}>{children || <Outlet />}</Box>
            <Footer />
        </MainLayoutRoot>
    );
};
